import { faGear } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { JoonUIColor, SPACING } from "@joonapp/web-shared"
import { useState } from "react"

const SettingsGearButton = ({ onClick }: { onClick?: () => void }) => {
  const [isHovering, setIsHovering] = useState(false)

  return (
    <button
      onClick={onClick}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: `1px solid ${JoonUIColor.border.default}`,
        borderRadius: SPACING.space2,
        height: "30px",
        width: "30px",
        backgroundColor: isHovering
          ? JoonUIColor.background.xlightGray
          : JoonUIColor.background.primaryNeutral,
      }}
    >
      <FontAwesomeIcon
        icon={faGear}
        color={JoonUIColor.icon.neutral}
        fontSize={14}
      />
    </button>
  )
}

export default SettingsGearButton
